module.exports = __webpack_public_path__ + "static/assets/152ba2c1378d2bb86b510fc801bd22b7.png";